
import CommonUtils from "@/common-utils";
import axios from "axios";
import "firebase/analytics";
import { DateTime } from 'luxon';
import { Component, Prop, Vue } from "vue-property-decorator";
import { MstCouponVO } from "../coupon/vo/coupon.vo";

@Component
export default class PrProductCouponsoduct extends Vue {
  @Prop() productCd!: string;
  couponLength = -1;
  noticePop = false; // 쿠폰 도움말

  coupons: Array<MstCouponVO> = [] as Array<MstCouponVO>;

  // 쿠폰 모두 받기 가능?
  get canDownloadCoupons(): boolean {
    const coupons = this.coupons.filter((coupon: MstCouponVO)=>{
      if(!coupon.maxDownloadableCouponCount) {
        return;
      }
      return coupon;
    })

    return coupons.length > 0;
  }

  // 쿠폰사용조건 문구생성
  getUseCouponTerms(coupon: MstCouponVO) {
    const minUsePrice = CommonUtils.toNumber(coupon.minUsePrice);
    const maxUsePrice = CommonUtils.toNumber(coupon.maxUsePrice);
    const maxDiscountPrice = CommonUtils.toNumber(coupon.maxDiscountPrice);
    const discountAmouont =  CommonUtils.toNumber(coupon.discountAmount);

    // 할인율
    if(coupon.discountType == '03') {
      return this.$t('coupon.t0002', [minUsePrice, maxUsePrice, discountAmouont]); // "t0002": "{0}원 이상 {1}원 이하 구매 시 {2}원 결제가능"
    } else {
      return this.$t('coupon.t0001', [minUsePrice, maxDiscountPrice]); // "t0001": "{0}만원 이상 구매 시 최대 {1}원 할인"
    }
  }

  // 1인최대지급수량 문구생성
  maxQuantityPerMemberTerms(coupon: MstCouponVO) {
    return this.$t('coupon.t0003', [coupon.maxQuantityPerMember.toString()]); // "t0003": "1인 {0}매 한정"
  }

  // 1일1회지급쿠폰 문구생성
  oncePerDayTerms(coupon: MstCouponVO) {
    return this.$t('coupon.t0004'); // "t0004": "1일 1회 지급 한정"
  }

  // 쿠폰 발급
  btnDownloadCoupon(coupon: MstCouponVO) {
    if(!coupon.maxDownloadableCouponCount) {
      return;
    }

    axios.post(`/coupon`, coupon).then(r=>{
      // 발급 완료
      if(r.data) {
        this.refreshCoupon(coupon);
        // 쿠폰이 지급됐습니다.
        this.$toast(this.$t('coupon.a0009'))
      }
    })
  }

  // 발급 가능한 쿠폰 개수
  couponabledCount(coupon: MstCouponVO) {
    return coupon.maxQuantityPerMember - coupon.memberCouponCnt;
  }

  // 쿠폰 받기 가능?
  canDownloadCoupon(coupon: MstCouponVO): boolean {
    return coupon.maxDownloadableCouponCount > 0;
  }

  // 쿠폰 모두 받기
  btnAppliedCoupons() {
    // 쿠폰을 모두 받으시겠습니까?
    if(confirm(this.$t('coupon.c0001').toString()) == false) {
      return;
    }
    axios.post(`/coupon/product/coupons`, {productCd: this.productCd}).then(r=>{
      
      // 전체 쿠폰리스트 다시 조회
      this.getCouponList();

      // 쿠폰이 지급됐습니다.
      this.$toast(this.$t('coupon.a0009'))
    })
  }

  //쿠폰 모두 받기 완료 됐는지 확인 로직
  checkAvailableAllCoupon(){
    const result = this.coupons.flatMap((coupon) => (coupon.maxQuantityPerMember - coupon.memberCouponCnt)>0).filter (val => val);
  return result.length >0;
  }

  // 쿠폰 새로고침
  refreshCoupon(coupon: MstCouponVO) {
    this.$set(coupon, 'memberCouponCnt', ++coupon.memberCouponCnt);
    this.$set(coupon, 'maxDownloadableCouponCount', --coupon.maxDownloadableCouponCount);
    this.$set(coupon, 'lastRegDate', DateTime.fromISO(new Date().toISOString()).toFormat('yyyy-LL-dd'));
  }

  getCouponList(){
    axios.get(`/coupon/product/${this.productCd}`).then(r=>{
      this.coupons = r.data;
      this.couponLength= this.coupons.length;
    })
  }

  created() {
    this.getCouponList();
  }
}
